/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   constants.tsx
 */

export const CAROUSEL_ARROW_CLASS = 'z-carousel-arrow'
export const CAROUSEL_ITEM_CLASS = 'z-carousel-item'
export const CAROUSEL_CONTAINER_CLASS = 'z-carousel-container'
export const CAROUSEL_SLIDER_CLASS = 'z-carousel-slider'

export const CAROUSEL_RESPONSIVE_DEFAULTS = {
  desktop: {
    breakpoint: { max: 9999, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

export const CAROUSEL_DEVICE_TYPES = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile',
}
